import { Injectable } from '@angular/core';
import { ChangePasswordIntl } from '@ebootis/login';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class ChangePasswordI18n extends ChangePasswordIntl {

	public constructor(
		private m_translateService: TranslateService
	) {
		super();
		this.m_translateService.onLangChange.subscribe({
			next: (e: Event) => {
				this.getAndInitTranslations();
			}
		});
		this.getAndInitTranslations();
	}

	private getAndInitTranslations(): void {
		this.m_translateService.get('CHANGE_PASSWORD.UI.TITLE.TEXT').subscribe({
			next: (res: string) => {
				this.titleText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.UI.FORM.OLD_PASSWORD.PLACEHOLDER').subscribe({
			next: (res: string) => {
				this.oldPasswordPlaceholder = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.UI.FORM.OLD_PASSWORD.ERROR.REQUIRED').subscribe({
			next: (res: string) => {
				this.oldPasswordErrorRequired = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.UI.FORM.OLD_PASSWORD.ERROR.OLD_PW_INCORRECT').subscribe({
			next: (res: string) => {
				this.oldPasswordErrorIncorrect = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.UI.FORM.NEW_PASSWORD.PLACEHOLDER').subscribe({
			next: (res: string) => {
				this.newPasswordPlaceholder = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.UI.FORM.NEW_PASSWORD.ERROR.REQUIRED').subscribe({
			next: (res: string) => {
				this.newPasswordErrorRequired = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.UI.FORM.RETYPE_PASSWORD.PLACEHOLDER').subscribe({
			next: (res: string) => {
				this.confirmPasswordPlaceholder = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.UI.FORM.CONFIRM_PASSWORD.ERROR.REQUIRED').subscribe({
			next: (res: string) => {
				this.confirmPasswordErrorRequired = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.UI.FORM.CONFIRM_PASSWORD.ERROR.EQUAL').subscribe({
			next: (res: string) => {
				this.confirmPasswordErrorEqual = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.BUTTON.SAVE.TEXT').subscribe({
			next: (res: string) => {
				this.saveButtonText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.BUTTON.RESET.TEXT').subscribe({
			next: (res: string) => {
				this.resetButtonText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.BUTTON.RESET.TEXT').subscribe({
			next: (res: string) => {
				this.resetButtonText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('CHANGE_PASSWORD.MESSAGE.PASSWORD_CHANGE.SUCCESS.TEXT').subscribe({
			next: (res: string) => {
				this.passwordChangeSuccessText = res;
				this.changes.next(null);
			}
		});
	}
}
